import React from 'react';
import cx from 'classnames';
import { Accordion as CarbonAccordion } from 'carbon-components-react';
import { accordion } from './Accordion.module.scss';
import { Row, Column } from 'gatsby-theme-carbon/src/components/Grid';

const Accordion = ({ className, ...rest }) => (
  <Row>
    <Column noGutterSm colLg={12}>
      <CarbonAccordion {...rest} className={cx(className, accordion)} />
    </Column>
  </Row>
);
export default Accordion;
